module.exports = __webpack_public_path__ + "img/42-ABITO-YUKI-U-COLORI-LINO-STAMPE-LINO13.196fa9c9.jpg";